import { useState } from 'react';
import { Text } from '../../../../components/Text';
import { Button } from 'primereact/button';
import { useDispatch, useSelector } from 'react-redux';
import { useUtility } from '../../../../context/UtilityContext';
import { unblockChatUser } from '../../../../reducers/wca/sales-support/sales-support-action';
import { set } from 'date-fns';
import Loader from '../../../../components/Loader';

const UnblockChat = () => {
  const { user } = useSelector((state) => state.wcaEnqChats);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { selectedMetadataId } = useUtility();

  const handleUnBlockChat = () => {
    setLoading(true);
    dispatch(
      unblockChatUser({
        metadataid: selectedMetadataId,
        phone: user.phone,
      }),
    ).unwrap().then(() => setLoading(false))
  };

  return (
    <div className="w-full p-3 text-center">
      <Loader visible={loading} />
      <Text type={'heading'}>You blocked this contact, click to unblock. </Text>
      <div className="flex gap-4 mt-2 justify-content-center">
        <Button
          label="Unblock"
          icon="pi pi-ban"
          severity="secondary"
          onClick={handleUnBlockChat}
          text
          rounded
        />
      </div>
    </div>
  );
};

export default UnblockChat;
